<template>
  <v-row class="d-flex align-center">
    <v-col cols="12" class="pa-0" :class="{ 'mb-n4': $vuetify.display.smAndUp }">
      <h4 class="text-h4 mt-6 pl-3">
        {{ $t('L_how_many_years') }}
      </h4>
    </v-col>
    <v-col cols="12" sm="8" md="9" class="pl-1 pb-0" :class="{ 'pr-1': $vuetify.display.xs }">
      <v-slider
        always-dirty
        :max="99"
        v-model="sliderAmount"
        @update:model-value="onSliderInput"
        :aria-labelledby="'How many years'"
      />
    </v-col>
    <v-col cols="12" sm="4" md="3" class="py-0" :class="$vuetify.display.xs ? 'mt-n4' : 'mt-0'">
      <YearsDisplay v-model="amount" @update:model-value="onTextInput" />
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import Slider from '@/components/Inputs/Slider/Slider.vue';
import YearsDisplay from './OngoingExpensesHowManyYearsDisplay.vue';
import LinkedSlider from './LinkedSlider.vue';

const componentOptions: ComponentOptions = {
  name: 'HowManyYears',
  extends: LinkedSlider,
  components: {
    YearsDisplay,
    Slider,
  },
};

export default defineComponent(componentOptions);
</script>
